import React from "react";
import { useSelector } from "react-redux";

import { IconAddons, IconIntegrations } from "~/components/icon";

import { selectStackPacksRouteType } from "../../../app/state/route/RouteSelectors";
import { useNavigateToLink } from "../../../components/react/link";
import { STACKPACKS_PATH } from "../../Routes";
import { BreadcrumbLayout } from "../BreadcrumbLayout";

const icons = {
	"Add-ons": IconAddons,
	Integrations: IconIntegrations,
};

export const StackPacksTypeBreadcrumb = () => {
	const type = useSelector(selectStackPacksRouteType);
	const link = useNavigateToLink(STACKPACKS_PATH, {
		search: ["timeRange", "timestamp", "detachedFilters", "type"],
	});

	// do not show breadcrumb if type not set
	if (!type) {
		return null;
	}

	const Icon = icons[type];

	return <BreadcrumbLayout icon={<Icon className="relative top-0.5" />} label={type} to={link} />;
};

StackPacksTypeBreadcrumb.PATH = STACKPACKS_PATH;
